/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Roots_HintInputs */

const cs_documents_roots_hint = /** @type {(inputs: Documents_Roots_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kořenové složky agentury — otevřením procházíte strom.`)
};

const en_documents_roots_hint = /** @type {(inputs: Documents_Roots_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Root folders for this agency — open one to browse its tree.`)
};

/**
* | output |
* | --- |
* | "Root folders for this agency — open one to browse its tree." |
*
* @param {Documents_Roots_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_roots_hint = /** @type {((inputs?: Documents_Roots_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Roots_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_roots_hint(inputs)
	return cs_documents_roots_hint(inputs)
});